'use client';
'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 });
var e = require('../../_virtual/_rollupPluginBabelHelpers.js'), r = require('next/link'),
  t = require('next/navigation'), l = require('react'),
  i = require('../../react-client/useLocale.js'), a = require('../../shared/utils.js'),
  u = require('./syncLocaleCookie.js');

function n(e) {
  return e && e.__esModule ? e : { default: e };
}

var f = n(r), o = n(l);

function c(r, n) {
  let {
    href: c,
    locale: s,
    localePrefixMode: d,
    onClick: p,
    prefetch: x,
    prefix: h,
    defaultLocale,
    ...q
  } = r;
  const v = t.usePathname(), _ = i.default(),
    j = s !== _, [k, L] = l.useState((() => ((_ === defaultLocale) && !j) ? c : a.isLocalizableHref(c) && ('never' !== d || j) ? a.prefixHref(c, h) : c));
  return l.useEffect((() => {
    v && L(a.localizeHref(c, s, _, v, h));
  }), [_, c, s, v, h]), j && (x = !1), o.default.createElement(f.default, e.extends({
    ref: n,
    href: k,
    hrefLang: j ? s : void 0,
    onClick: function(e) {
      u.default(v, _, s), p && p(e);
    },
    prefetch: x,
  }, q));
}

const s = l.forwardRef(c);
s.displayName = 'ClientLink', exports.default = s;
